import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Eye } from "lucide-react";

export default function TopBar() {
  const { user, logout } = useAuth();
  return (
    <div className="relative z-30 flex items-center justify-between px-6 py-4 sm:px-10">
      <Link to="/" className="flex items-center gap-2 group" data-testid="topbar-home-link">
        <Eye className="w-5 h-5 text-cyan-400 group-hover:scale-110 transition" />
        <span className="font-display text-sm tracking-[0.3em] uppercase text-white/90">Soulciety</span>
      </Link>
      <nav className="flex items-center gap-2 sm:gap-4 text-xs sm:text-sm font-mono uppercase tracking-widest">
        {user ? (
          <>
            {user.role === "admin" && (
              <Link to="/admin" className="text-white/70 hover:text-cyan-400 transition" data-testid="topbar-admin-link">Admin</Link>
            )}
            {user.role === "influencer" && (
              <>
                <Link to="/influencer/dashboard" className="text-white/70 hover:text-cyan-400 transition" data-testid="topbar-influencer-dashboard">VIP</Link>
                <Link to="/vault" className="text-white/70 hover:text-cyan-400 transition" data-testid="topbar-vault-link">Vault</Link>
              </>
            )}
            {user.role === "user" && user.membership_active && (
              <Link to="/dashboard" className="text-white/70 hover:text-cyan-400 transition" data-testid="topbar-dashboard-link">Dashboard</Link>
            )}
            <button onClick={logout} className="text-white/70 hover:text-rose-400 transition" data-testid="topbar-logout-btn">Logout</button>
          </>
        ) : (
          <>
            <Link to="/login" className="text-white/70 hover:text-cyan-400 transition" data-testid="topbar-login-link">Login</Link>
            <Link to="/register" className="text-white/70 hover:text-cyan-400 transition" data-testid="topbar-register-link">Register</Link>
          </>
        )}
      </nav>
    </div>
  );
}
